import { NgModule, ModuleWithProviders } from '@angular/core';

import { NgChartsModule } from 'ng2-charts';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { AuthorizationService } from './authorization.service';
import { WebsocketService } from './websocket.service';
import { ChannelWebsocketService } from './channel-websocket.service';
import { ViewSummaryComponent } from './view-summary/view-summary.component';

import { SignOutComponent } from './signout/sign-out.component';
import { LayoutComponent } from './layout/layout.component';
import { HelpBankComponent } from './layout/help1/help-bank.component';
import { HelpOverviewComponent } from './layout/help1/help-overview.component';
import { HelpSearchComponent } from './layout/help1/help-search.component';

import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { SanitizeHtmlDirective } from './report-viewer/ sanitize-html.directive';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DecisionsSetPopupComponent } from './decisions-set-popup/decisions-set-popup.component';
import { ExecutionPopupComponent } from './execution-popup/execution-popup.component';
import { DecisionsSubmitPopupComponent } from './decisions-submit-popup/decisions-submit-popup.component';
import { RunSubmitPopupComponent } from './run-submit-popup/run-submit-popup.component';
// import { FlashMessagesModule } from 'angular2-flash-messages';
// import { ChatDashboardComponent } from './../session-control/chat-controls/chat-dashboard/chat-dashboard.component';
// import { ChatWindowComponent } from './../session-control/chat-controls/chat-window/chat-window.component';
// import { ChatChannelService } from './../session-control/chat-controls/chat-channel.service';
// import { ChatStatusChannelService } from './../session-control/chat-controls/chat-status-channel.service';
import { SecurityDecisionsComponent } from './../session-control/security-decisions/security-decisions.component';
// import { DecisionStatusComponent } from './../session-control/decision-status/decision-status.component';
import { InputFormsPopupComponent } from './input-forms-popup/input-forms-popup.component';

import { TextEditorComponent } from './text-editor/text-editor.component';
import { QuillModule } from 'ngx-quill'
import { AdminAddEconomyComponent } from './add-economy/admin-add-economy.component';
import { AdminFindUserComponent } from '../admin/find-user/admin-find-user.component';
import { ResetPasswordRendererComponent } from '../admin/find-user/reset-password-button.component';
import { WorksessionDetailsComponent } from '../admin/find-user/worksession-details.component';
import { AgGridModule } from "ag-grid-angular";
import { SearchHighlighterPipe } from '../search-highlighter.pipe';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    SignOutComponent,
    ViewSummaryComponent,
    LayoutComponent,
    HelpBankComponent,
    HelpOverviewComponent,
    HelpSearchComponent,
    ReportViewerComponent,
    ChangePasswordComponent,
    DecisionsSetPopupComponent,
    ExecutionPopupComponent,
    DecisionsSubmitPopupComponent,
    RunSubmitPopupComponent,
    // ChatDashboardComponent,
    // DecisionStatusComponent,
    SecurityDecisionsComponent,
    // ChatWindowComponent,
    AdminAddEconomyComponent,
    SanitizeHtmlDirective,
    TextEditorComponent,
    AdminFindUserComponent,
    ResetPasswordRendererComponent,
    WorksessionDetailsComponent,
    SearchHighlighterPipe,
    InputFormsPopupComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgChartsModule,
    // FlashMessagesModule,
    //NguiPopupModule,
    QuillModule,
    AgGridModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
    // ChatChannelService,
    // ChatStatusChannelService,
    provideNgxMask()
  ],
  exports: [
    SignOutComponent,
    ViewSummaryComponent,
    LayoutComponent,
    HelpBankComponent,
    HelpOverviewComponent,
    HelpSearchComponent,
    ReportViewerComponent,
    ChangePasswordComponent,
    DecisionsSetPopupComponent,
    ExecutionPopupComponent,
    DecisionsSubmitPopupComponent,
    RunSubmitPopupComponent,
    // DecisionStatusComponent,
    SecurityDecisionsComponent,
    // ChatDashboardComponent,
    // ChatWindowComponent,
    AdminAddEconomyComponent,
    TextEditorComponent,
    AdminFindUserComponent,
    ResetPasswordRendererComponent,
    WorksessionDetailsComponent,
    InputFormsPopupComponent
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [AuthorizationService, WebsocketService, ChannelWebsocketService]
    };
  }
}
